import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NoteAttachment {
  id?: number;
  name: string;
  cloud_key: string;
  type?: string;
  size?: number;
}

@Injectable({
  providedIn: 'root',
})
export class noteService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/notes');
  }

  // Create note with files in single request
  createWithFiles(
    data: { content: string; lead_id: number },
    files: File[],
  ): Observable<any> {
    const formData = new FormData();
    formData.append('content', data.content);
    formData.append('lead_id', data.lead_id.toString());

    files.forEach((file) => {
      formData.append('files', file);
    });

    return this.http.post(`${environment.apiUrl}/notes/with-files`, formData);
  }

  // Update note with files in single request
  updateWithFiles(
    id: number,
    data: { content?: string; removeAttachmentIds?: number[] },
    files: File[],
  ): Observable<any> {
    const formData = new FormData();

    if (data.content !== undefined) {
      formData.append('content', data.content);
    }
    if (data.removeAttachmentIds?.length) {
      formData.append('removeAttachmentIds', JSON.stringify(data.removeAttachmentIds));
    }

    files.forEach((file) => {
      formData.append('files', file);
    });

    return this.http.patch(`${environment.apiUrl}/notes/${id}/with-files`, formData);
  }

  getAttachmentUrl(
    key: string,
    folder?: string,
  ): Observable<{ url: string; size: number }> {
    const params: any = {};
    if (folder) params.folder = folder;
    return this.http.get<{ url: string; size: number }>(
      `${environment.apiUrl}/notes/attachment-url/${key}`,
      { params },
    );
  }
}